window.__assetPrefix__ = 'https://da4uatwxo4s4i.cloudfront.net/time-and-attendance';